import { render } from "./DualSelectInput.vue?vue&type=template&id=f1cca810&scoped=true"
import script from "./DualSelectInput.vue?vue&type=script&lang=js"
export * from "./DualSelectInput.vue?vue&type=script&lang=js"

import "./DualSelectInput.vue?vue&type=style&index=0&id=f1cca810&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1cca810"]])

export default __exports__